module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/marika-tarczynska-9bac6cd560adb2cb41fa9779d088d084.png";